import { render, staticRenderFns } from "./DerivationList.vue?vue&type=template&id=4f5a9064&scoped=true&"
import script from "./DerivationList.vue?vue&type=script&lang=js&"
export * from "./DerivationList.vue?vue&type=script&lang=js&"
import style0 from "./DerivationList.vue?vue&type=style&index=0&id=4f5a9064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a9064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4f5a9064', component.options)
    } else {
      api.reload('4f5a9064', component.options)
    }
    module.hot.accept("./DerivationList.vue?vue&type=template&id=4f5a9064&scoped=true&", function () {
      api.rerender('4f5a9064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/DerivationList.vue"
export default component.exports